/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponseClinicDto } from '../../models/response-clinic-dto';

export interface ClinicDoctorControllerGetClinicsForDoctor$Params {

/**
 * The tenant ID
 */
  tenant: string;

/**
 * The doctor ID
 */
  doctorId: string;

/**
 * Filter clinics by specialization
 */
  specialization?: string;
}

export function clinicDoctorControllerGetClinicsForDoctor(http: HttpClient, rootUrl: string, params: ClinicDoctorControllerGetClinicsForDoctor$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResponseClinicDto>>> {
  const rb = new RequestBuilder(rootUrl, clinicDoctorControllerGetClinicsForDoctor.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('doctorId', params.doctorId, {});
    rb.query('specialization', params.specialization, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ResponseClinicDto>>;
    })
  );
}

clinicDoctorControllerGetClinicsForDoctor.PATH = '/thalea-clinics/clinic-doctors/{tenant}/{doctorId}';
